import "../css/styles.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
// O Link é importado para podermos usá-lo
import { Link } from "react-router-dom";
import "chartjs-adapter-date-fns";

function formatCurrency(value) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value || 0);
}

function Graficobarra() {
  // --- States (sem alteração) ---
  const [emandamento, setEmandamento] = useState(0);
  const [atrasado, setAtrasado] = useState(0);
  const [concluido, setConcluido] = useState(0);
  const [naoIniciado, setNaoIniciado] = useState(0);
  const [agricultura, setAgricultura] = useState(0);
  const [meioambiente, setMeioambiente] = useState(0);
  const [governo, setGoverno] = useState(0);
  const [obras, setObras] = useState(0);
  const [saeg, setSaeg] = useState(0);
  const [codesg, setCodesg] = useState(0);
  const [planejamento, setPlanejamento] = useState(0);
  const [saude, setSaude] = useState(0);
  const [educacao, setEducacao] = useState(0);
  const [seguranca, setSeguranca] = useState(0);
  const [esporte, setEsporte] = useState(0);
  const [cultura, setCultura] = useState(0);
  const [turismo, setTurismo] = useState(0);
  const [mulher, setMulher] = useState(0);
  const [defesacivil, setDefesaCivil] = useState(0);
  const [administracao, setAdministracao] = useState(0);

  // --- useEffect (sem alteração) ---
  useEffect(() => {
    const fetchData = async () => {
      try {
        const responses = await Promise.all([
          axios.get("/api/getemandamento"),
          axios.get("/api/getatrasado"),
          axios.get("/api/getconcluido"),
          axios.get("/api/getnaoiniciado"),
          axios.get("/api/quantidade-por-secretaria"),
        ]);

        setEmandamento(responses[0].data?.[0]?.emandamento ?? 0);
        setAtrasado(responses[1].data?.[0]?.atrasado ?? 0);
        setConcluido(responses[2].data?.[0]?.concluido ?? 0);
        setNaoIniciado(responses[3].data?.[0]?.naoiniciado ?? 0);

        const nomeParaEstado = {
          "02.13 - Secretaria Municipal da Agricultura": setAgricultura,
          "02.17 - Secretaria Municipal de Meio Ambiente": setMeioambiente,
          "02.15 - Secretaria Municipal de Governo e Gestão Estratégica":
            setGoverno,
          "02.07 - Secretaria Municipal de Obras e Serviços Municipais":
            setObras,
          SAEG: setSaeg,
          CODESG: setCodesg,
          "02.03 - Secretaria Municipal de Planejamento, Coordenação e Habitação":
            setPlanejamento,
          "02.11 - Secretaria Municipal de Saúde": setSaude,
          "02.09 - Secretaria Municipal da Educação": setEducacao,
          "02.08 - Secretaria Municipal de Segurança e Mobilidade Urbana":
            setSeguranca,
          "02.11 - Secretaria Municipal de Turismo e Lazer": setTurismo,
          "02.10 - Secretaria Municpal de Esportes": setEsporte,
          "02.16 - Secretaria Municipal da Cultura": setCultura,
          "02.20 -Secretaria de Políticas para as Mulheres": setMulher,
          "Assessoria Especial de Defesa Civil": setDefesaCivil,
          "02.05 - Secretaria Municipal da Administração": setAdministracao,
        };
        responses[4].data.forEach((item) => {
          const setter = nomeParaEstado[item.secretaria];
          if (setter) setter(item.total ?? 0);
        });
      } catch (err) {
        console.error("Erro ao buscar dados:", err);
      }
    };

    fetchData();
  }, []);

  return (
    <div
      className="px-4 py-4"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      <div className="container">
        {/* Header e Botão Voltar (Sem alteração) */}
        <div className="mb-4">
          <Link
            to="/"
            className="btn btn-outline-primary"
            style={{
              marginRight: "10px",
              borderRadius: "20px",
              padding: "8px 20px",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.3s ease",
            }}
          >
            <i className="fas fa-arrow-left"></i>
            Voltar ao Dashboard
          </Link>
        </div>

        <div className="dashboard-header mb-4">
          <h2
            className="m-0"
            style={{
              fontSize: "1.75rem",
              fontWeight: "bold",
              color: "#2c3e50",
              borderBottom: "3px solid #3498db",
              paddingBottom: "10px",
              display: "inline-block",
            }}
          >
            Sistema de Gestão de Processos - Prefeitura de Guaratinguetá
          </h2>
          <p
            className="text-center text-muted"
            style={{
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            Painel de controle com informações quantitativas e distribuição dos
            processos por secretaria
          </p>
        </div>

        {/* --- ATUALIZAÇÃO DOS CARDS (LINKS + COR) --- */}
        <div className="row g-4 mb-4">
          {/* Card 1: Projetos em Andamento */}
          <div className="col-md-3">
            <Link
              to="/projetocompleto?status=emandamento"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div
                className="card shadow-sm h-100"
                style={{
                  borderRadius: "15px",
                  border: "none",
                  transition: "transform 0.2s",
                  cursor: "pointer",
                  backgroundColor: "#fff", // <-- COR BRANCA ADICIONADA
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.03)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i
                      className="fas fa-spinner me-3"
                      style={{ fontSize: "20px", color: "#3498db" }}
                    ></i>
                    <h5
                      className="card-title mb-0"
                      style={{ color: "#2c3e50" }}
                    >
                      Projetos em Andamento
                    </h5>
                  </div>
                  <h3
                    className="mb-2"
                    style={{ fontSize: "20px", color: "#2c3e50" }}
                  >
                    {emandamento}
                  </h3>
                  <p className="text-muted mb-0">
                    Total de projetos em execução
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Card 2: Projetos Atrasados */}
          <div className="col-md-3">
            <Link
              to="/projetocompleto?status=atrasado"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div
                className="card shadow-sm h-100"
                style={{
                  borderRadius: "15px",
                  border: "none",
                  transition: "transform 0.2s",
                  cursor: "pointer",
                  backgroundColor: "#fff", // <-- COR BRANCA ADICIONADA
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.03)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i
                      className="fas fa-exclamation-triangle me-3"
                      style={{ fontSize: "20px", color: "#e74c3c" }}
                    ></i>
                    <h5
                      className="card-title mb-0"
                      style={{ color: "#2c3e50" }}
                    >
                      Projetos Atrasados
                    </h5>
                  </div>
                  <h3
                    className="mb-2"
                    style={{ fontSize: "20px", color: "#2c3e50" }}
                  >
                    {atrasado}
                  </h3>
                  <p className="text-muted mb-0">Projetos fora do prazo</p>
                </div>
              </div>
            </Link>
          </div>

          {/* Card 3: Projetos Finalizados */}
          <div className="col-md-3">
            <Link
              to="/projetocompleto?status=concluido"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div
                className="card shadow-sm h-100"
                style={{
                  borderRadius: "15px",
                  border: "none",
                  transition: "transform 0.2s",
                  cursor: "pointer",
                  backgroundColor: "#fff", // <-- COR BRANCA ADICIONADA
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.03)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <div className="card-body p-4">
                  <div
                    className="d-flex align-items-center mb-3"
                    style={{ fontSize: "20px" }}
                  >
                    <i
                      className="fas fa-check-circle me-3"
                      style={{ fontSize: "20px", color: "#2ecc71" }}
                    ></i>
                    <h5
                      className="card-title mb-0 "
                      style={{ fontSize: "20px", color: "#2c3e50" }}
                    >
                      Projetos Finalizados
                    </h5>
                  </div>
                  <h3
                    className="mb-2"
                    style={{ fontSize: "20px", color: "#2c3e50" }}
                  >
                    {concluido}
                  </h3>
                  <p className="text-muted mb-0" style={{ fontSize: "20px" }}>
                    Total de projetos concluídos
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Card 4: Não Iniciados */}
          <div className="col-md-3">
            <Link
              to="/projetocompleto?status=naoiniciado"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div
                className="card shadow-sm h-100"
                style={{
                  borderRadius: "15px",
                  border: "none",
                  transition: "transform 0.2s",
                  cursor: "pointer",
                  backgroundColor: "#fff", // <-- COR BRANCA ADICIONADA
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.03)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i
                      className="fas fa-pause-circle me-3"
                      style={{ fontSize: "24px", color: "#95a5a6" }}
                    ></i>
                    <h5
                      className="card-title mb-0"
                      style={{ color: "#2c3e50" }}
                    >
                      Não Iniciados
                    </h5>
                  </div>
                  <h3
                    className="mb-2"
                    style={{ fontSize: "20px", color: "#2c3e50" }}
                  >
                    {naoIniciado}
                  </h3>
                  <p className="text-muted mb-0">Projetos aguardando início</p>
                </div>
              </div>
            </Link>
          </div>
        </div>
        {/* --- FIM DA ATUALIZAÇÃO --- */}

        {/* Lista de Secretarias (Sem alteração) */}
        <div
          className="card shadow-sm"
          style={{
            borderRadius: "15px",
            border: "none",
            backgroundColor: "rgba(255,255,255,0.9)",
          }}
        >
          <div className="card-body p-4">
            <div
              className="section-header mb-4"
              style={{
                borderBottom: "2px solid #bdc3c7",
                paddingBottom: "8px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <i className="fas fa-building" style={{ color: "#34495e" }}></i>
              <h5
                className="card-title mb-0"
                style={{
                  color: "#34495e",
                  fontSize: "1.25rem",
                }}
              >
                Distribuição por Secretaria
              </h5>
            </div>
            <div className="row g-3">
              {[
                {
                  title: "Agricultura",
                  value: agricultura,
                  icon: "fa-leaf",
                  path: "/projetocompleto?id_secretaria=5",
                },
                {
                  title: "Obras",
                  value: obras,
                  icon: "fa-hard-hat",
                  path: "/projetocompleto?id_secretaria=12",
                },
                {
                  title: "Governo",
                  value: governo,
                  icon: "fa-landmark",
                  path: "/projetocompleto?id_secretaria=4",
                },
                {
                  title: "Meio Ambiente",
                  value: meioambiente,
                  icon: "fa-tree",
                  path: "/projetocompleto?id_secretaria=6",
                },
                {
                  title: "SAEG",
                  value: saeg,
                  icon: "fa-tint",
                  path: "/projetocompleto?id_secretaria=9",
                },
                {
                  title: "CODESG",
                  value: codesg,
                  icon: "fa-building",
                  path: "/projetocompleto?id_secretaria=23",
                },
                {
                  title: "Planejamento",
                  value: planejamento,
                  icon: "fa-tasks",
                  path: "/projetocompleto?id_secretaria=27",
                },
                {
                  title: "Saúde",
                  value: saude,
                  icon: "fa-heartbeat",
                  path: "/projetocompleto?id_secretaria=17",
                },
                {
                  title: "Educação",
                  value: educacao,
                  icon: "fa-graduation-cap",
                  path: "/projetocompleto?secretaria=7",
                },
                {
                  title: "Segurança",
                  value: seguranca,
                  icon: "fa-shield-alt",
                  path: "/projetocompleto?id_secretaria=20",
                },
                {
                  title: "Turismo",
                  value: turismo,
                  icon: "fa-umbrella-beach",
                  path: "/projetocompleto?id_secretaria=3",
                },
                {
                  title: "Esportes e Lazer",
                  value: esporte,
                  icon: "fa-futbol",
                  path: "/projetocompleto?id_secretaria=10",
                },
                {
                  title: "Cultura",
                  value: cultura,
                  icon: "fa-theater-masks",
                  path: "/projetocompleto?id_secretaria=26",
                },
                {
                  title: "Mulheres",
                  value: mulher,
                  icon: "fa-venus",
                  path: "/projetocompleto?id_secretaria=1",
                },
                {
                  title: "Defesa Civil",
                  value: defesacivil,
                  icon: "fa-house-damage",
                  path: "/projetocompleto?id_secretaria=2",
                },
                {
                  title: "Administração",
                  value: administracao,
                  icon: "fa-cogs",
                  path: "/projetocompleto?id_secretaria=8",
                }, // (Esta vírgula extra pode ser um erro, mas mantive como estava)
                ,
              ].map(
                (item, index) =>
                  // Adiciona uma checagem para pular o item 'undefined' (da vírgula extra)
                  item && (
                    <div key={index} className="col-md-3 col-sm-6">
                      <Link to={item.path} style={{ textDecoration: "none" }}>
                        <div
                          className="card h-100 border-0 shadow-sm"
                          style={{
                            backgroundColor: "#f8f9fa",
                            borderRadius: "12px",
                            transition:
                              "transform 0.3s ease, box-shadow 0.3s ease",
                            cursor: "pointer",
                          }}
                        >
                          <div className="card-body d-flex align-items-center">
                            <div
                              className="me-3"
                              style={{
                                width: "48px",
                                height: "48px",
                                borderRadius: "12px",
                                background:
                                  "linear-gradient(135deg, #3498db, #2980b9)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className={`fas ${item.icon}`}
                                style={{
                                  fontSize: "1.5rem",
                                  color: "white",
                                }}
                              ></i>
                            </div>
                            <div>
                              <h6
                                className="card-subtitle mb-2"
                                style={{
                                  color: "#7f8c8d",
                                  fontSize: "0.875rem",
                                }}
                              >
                                {item.title}
                              </h6>
                              <p
                                className="card-text"
                                style={{
                                  fontSize: "1.25rem",
                                  fontWeight: "600",
                                  color: "#2c3e50",
                                  marginBottom: 0,
                                }}
                              >
                                {item.value}
                                <small
                                  style={{
                                    fontSize: "0.875rem",
                                    color: "#95a5a6",
                                    marginLeft: "4px",
                                  }}
                                >
                                  processos
                                </small>
                              </p>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Graficobarra;
